import React from "react";
import styled from "styled-components";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import RoomIcon from "@mui/icons-material/Room";
import PhoneIcon from "@mui/icons-material/Phone";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import { mobile, tabletPortrait } from "../responsive";
import { Link } from "react-router-dom";
import { Instagram } from "@mui/icons-material";

/* ---------------- Container ---------------- */

const Container = styled.footer`
  background: linear-gradient(180deg, #c9eeff 0%, #e9f7ff 100%);
  padding: 50px 40px;
  display: flex;
  gap: 40px;

  ${mobile({ flexDirection: "column", padding: "40px 20px" })}
  ${tabletPortrait({ flexDirection: "column" })}
`;

/* ---------------- Sections ---------------- */

const Section = styled.div`
  flex: 1;
`;

/* ---------------- Logo ---------------- */

const Logo = styled.div`
  margin-bottom: 20px;
`;

/* ---------------- Description ---------------- */

const Desc = styled.p`
  font-size: 14px;
  line-height: 1.7;
  color: #333;
  max-width: 320px;
`;

/* ---------------- Social ---------------- */

const SocialContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

const SocialIcon = styled.a`
  width: 40px;
  height: 40px;
  background-color: ${({ bg }) => bg};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.85;
  }
`;

/* ---------------- Titles ---------------- */

const Title = styled.h4`
  margin-bottom: 20px;
  font-weight: 700;
  color: #1a438e;
`;

/* ---------------- Links ---------------- */

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 30px;
  row-gap: 10px;

  ${mobile({
    gridTemplateColumns: "1fr",
  })}
`;

const ListItem = styled.li`
  margin-bottom: 4px;

  a {
    text-decoration: none;
    color: #333;
    font-size: 16px;
    transition: color 0.2s ease;

    &:hover {
      color: #1a438e;
    }
  }
`;

/* ---------------- Contact ---------------- */

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  margin-bottom: 12px;
  color: #333;
`;

/* ---------------- Bottom Bar ---------------- */

const BottomBar = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #bcdff1;
  text-align: center;
  font-size: 13px;
  color: #555;
  background-color: #e9f7ff;
`;

const FooterWrapper = styled.div`
  background: linear-gradient(180deg, #c9eeff 0%, #e9f7ff 100%);
`;

/* ---------------- Footer Component ---------------- */

const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        {/* -------- Left -------- */}
        <Section>
          <Logo>
            <Link to="/">
              <img
                src={require("../Assets/Logo/Impact.png")}
                height={70}
                alt="Impact Technologies"
              />
            </Link>
          </Logo>

          <Desc>
            Impact Technologies delivers innovative solutions in Robotics,
            Automation, AI Labs, and skill-based technical education to empower
            students and industries for a smarter future.
          </Desc>

          <SocialContainer>
            <SocialIcon
              bg="#3b5999"
              href="https://www.facebook.com/impacttech1?mibextid=LQQJ4d"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon />
            </SocialIcon>

            <SocialIcon
              bg="#55acee"
              href="https://twitter.com/impact358"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon />
            </SocialIcon>

            <SocialIcon
              bg="#55acee"
              href="https://www.instagram.com/impact358"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram />
            </SocialIcon>
          </SocialContainer>
        </Section>

        {/* -------- Center -------- */}
        <Section>
          <Title>Quick Links</Title>
          <List>
            <ListItem><Link to="/">Home</Link></ListItem>
            <ListItem><Link to="/about">About Us</Link></ListItem>
            <ListItem><Link to="/products">Products</Link></ListItem>
            <ListItem><Link to="/training">Training & Projects</Link></ListItem>
            <ListItem><Link to="/automation">Automation & Solutions</Link></ListItem>
            <ListItem><Link to="/cart">Cart</Link></ListItem>
            <ListItem><Link to="/wishlist">Wishlist</Link></ListItem>
            <ListItem><Link to="/terms-conditions">Terms & Conditions</Link></ListItem>
            <ListItem>
              <Link to="/privacyPolicy">Privacy</Link> /{" "}
              <Link to="/refundPolicy">Refund</Link>
            </ListItem>
          </List>
        </Section>

        {/* -------- Right -------- */}
        <Section>
          <Title>Contact Us</Title>

          <ContactItem>
            <RoomIcon />
            A-14, T-Point, Pravesh Vihar, K-Block Shastri Nagar, Meerut, UP – 250004
          </ContactItem>

          <ContactItem>
            <PhoneIcon />
            +91 9557240576, 6396886492
          </ContactItem>

          <ContactItem>
            <MailOutlinedIcon />
            impact358@gmail.com
          </ContactItem>
        </Section>
      </Container>

      <BottomBar>
        © {new Date().getFullYear()} Impact Technologies. All Rights Reserved.
      </BottomBar>
    </FooterWrapper>
  );
};

export default Footer;